import { InjectionToken } from '@angular/core';

/**
 * True only in an app's `e2e` build configuration. Each app provides it from
 * its own `environment.e2e`; it defaults to false so a missing provider can
 * never enable the E2E sign-in path.
 */
export const E2E_MODE = new InjectionToken<boolean>('E2E_MODE', {
  providedIn: 'root',
  factory: () => false,
});
